const styles = () => ({
    containerSurvey: {
        paddingTop: '20px',
        paddingBottom: '60px',
    },
    centerProgress: {
        textAlign: 'center',
    },
});

export default styles;
